import { FC, useCallback, useContext } from "react";

import { Form, SubmitButton, useForm } from "capitalrx-components-2.0/lib/forms";
import { useAlert } from "capitalrx-components-2.0/lib/general";
import { Shelf, Stack, useResponsive } from "capitalrx-components-2.0/lib/layout";

import { submitProviderManagementAPI, updatePaymentPreferenceAPI } from "@/api";
import { ProviderManagement } from "@/api/interfaces";
import { PROVIDER_MANAGEMENT_LAYOUT } from "@/constants";
import { ANALYTIC_EVENTS, logEvent } from "@/service/analyticsService";
import { AuthenticationContext, ThemeSelectorContext } from "@/context";
import { getThemeButton } from "@/utils";


interface ProviderSubmitProps {
  readonly onComplete: () => void;
  readonly paymentPreference: ProviderManagement.PaymentPreferenceSchema;
}

export const ProviderSubmit: FC<ProviderSubmitProps> = ({ onComplete, paymentPreference }) => {
  const { getAuthToken } = useContext(AuthenticationContext);
  const { primary_color, primary_hover_color } = useContext(ThemeSelectorContext);
  const { isCompressed } = useResponsive(PROVIDER_MANAGEMENT_LAYOUT);
  const ButtonGroup = isCompressed ? Stack : Shelf;
  const showAlert = useAlert();

  const form = useForm();

  const submitHandler = useCallback(async () => {
    logEvent(ANALYTIC_EVENTS.PROVIDER_MANAGEMENT.submit);

    try {
      // Submit provider management record for review + update payment preference to in review
      if (paymentPreference?.id) {
        await updatePaymentPreferenceAPI({
          id: Number(paymentPreference.id),
          network_enrollment_status: "in_review",
          provider_network_id: paymentPreference.provider_network_id,
        }, getAuthToken());
      }
      await submitProviderManagementAPI(getAuthToken());
      logEvent(ANALYTIC_EVENTS.PROVIDER_MANAGEMENT.submit_success);
      onComplete();

    } catch (error) {
      showAlert({
        type: "error",
        style: "banner",
        message: "Failed to submit provider details. Please try again later.",
      });
      logEvent(ANALYTIC_EVENTS.ERRORS.providerManagementSubmit);
    }
  }, []);

  return (
    <Form form={form} onSubmit={submitHandler}>
      <Stack alignment={isCompressed ? "span" : "left"} style={{ paddingBottom: "16px" }}>
        <ButtonGroup>
          <SubmitButton appearance={getThemeButton("primary", primary_color, primary_hover_color)} testId="provider_submit_button" >Submit for Review</SubmitButton>
        </ButtonGroup>
      </Stack>
    </Form>
  );
};
